import type { BadgeVariants } from "@/components/ui/badge";
import type { MCampaignPush, MCampaignPushStage } from "@/types";

export const M_CAMPAIGN_PUSH_STATUS_VARIANTS: Record<MCampaignPush["status"], BadgeVariants["variant"]> = {
  running: "info",
  succeeded: "success",
  failed: "danger",
};

export const M_CAMPAIGN_PUSH_STAGE_LABELS: Record<MCampaignPushStage, string> = {
  campaigns: "Campaigns",
  adsets: "Adsets",
  adset_bids: "Adset bids",
  creatives: "Creatives",
  ads: "Ads",
};

export const M_CAMPAIGN_PUSH_STAGE_SINGULAR_LABELS: Record<MCampaignPushStage, string> = {
  campaigns: "Campaign",
  adsets: "Adset",
  adset_bids: "Adset bid",
  creatives: "Creative",
  ads: "Ad",
};

export const pushFailureAttemptsLabel = (attempts: number) => {
  if (attempts === 0) return "Not sent to Meta";
  if (attempts === 1) return "Not retried";
  return `Failed after ${attempts} attempts`;
};
